import { Fancybox } from "@fancyapps/ui";
import "jquery-validation/dist/jquery.validate.min";
import "jquery-validation/dist/localization/messages_fr";
import { blockMap } from "../components/map";
import { logoSlider } from "../components/logo-slider";
import { useCaseSlider } from "../components/use-case-slider";
import { fullHeightSlider } from "../components/full-height-slider";
import { initializeSocialShare } from "../components/social";
import { initializeInputFile } from "../components/input-file";
import { initializeSearchbar } from "../components/searchbar";
import { initializeCookies } from "../components/cookies";
import { initializeBootstrap } from "../components/bootstrap";
import { initializeTitleCatalogNavbar } from "../components/title-catalog-navbar";
import { initializeTableNavbar } from "../components/table-navbar";
import { initializeNavbar } from "../components/navbar";
import { initializeNewsletterForm } from "../components/newsletter";
import { initializeContactHeadband } from "../components/contact-headband";

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    Fancybox.bind("[data-fancybox]");

    logoSlider();
    useCaseSlider();
    fullHeightSlider();
    blockMap();
    initializeSocialShare();
    initializeInputFile();
    initializeSearchbar();
    initializeCookies();
    initializeBootstrap();
    initializeTitleCatalogNavbar();
    initializeTableNavbar();
    initializeNavbar();
    initializeNewsletterForm();
    initializeContactHeadband();

    if (window.acf) {
      window.acf.addAction("render_block_preview/type=logo-slider", logoSlider);
      window.acf.addAction("render_block_preview/type=map", blockMap);
      window.acf.addAction(
        "render_block_preview/type=full-height-slider",
        fullHeightSlider
      );
      window.acf.addAction(
        "render_block_preview/type=use-case-slider",
        useCaseSlider
      );
    }
  },
};
